import React from 'react';
import classNames from 'classnames';

import ExternalLink from 'src/components/common/external-link';
import { ReactComponent as DavidStarIcon } from 'src/assets/icons/davidstar.svg';
import { ReactComponent as LikeIcon } from 'src/assets/icons/like.svg';

import { LOCALES, SOCIAL_LINKS, TeamBlockData } from 'src/constants';

import './team.scss';

const Team = () => {
  const withSocialLinks = SOCIAL_LINKS.length > 0;

  const classes = classNames(
    'team__social',
    !withSocialLinks && 'team__social_without-social-links'
  );

  return (
    <section className="team">
      <div className="team__info">
        <div className="team__text">
          <h2 className="team__heading">הצוות שלנו</h2>
          <p className="team__paragraph">
            הצוות שלנו הוא קבוצה של אנשי מקצוע מסורים המאוחדים ברצון משותף לשמר את כבודם של המנוחים
            ולשקם את המצבות שלהם . אנו גאים בכך שהעבודה שלנו מאפשרת לנו לשמור על מורשת ולהוות דוגמא
            בעבודה ושירות. כל אחד מאיתנו שם את ידו, את הניסיון האישי שלו כדי לעזור ללקוחות היקרים
            שלנו לשמר את זכרם של המנוחים היקרים ללבכם. הקשר עם כל משפחה והמשפחה היא חוויה מיוחד
            ונותנת לנו את ההזדמנות להיות שותפים למצווה.
          </p>
        </div>
        <div className="team__features">
          <div className="team__feature team__feature_star">
            <DavidStarIcon />
            <span className="team__feature-text">
              <b className="team__text-title">יותר מ2 מיליון</b>
              <span className="team__text-description">מצבות במאגר שלנו</span>
            </span>
          </div>
          <div className="team__feature team__feature_like">
            <LikeIcon />
            <span className="team__feature-text">
              <b className="team__text-title">{TeamBlockData.CUSTOMERS_COUNT}</b>
              <span className="team__text-description">לקוחות מרוצים</span>
            </span>
          </div>
        </div>
      </div>

      <div className="team__video">
        <iframe
          className="team__video-frame"
          width="440"
          height="586"
          src={TeamBlockData.VIDEO_URL}
          title="YouTube video player"
          allow="accelerometer; gyroscope;"
          allowFullScreen
        />
      </div>
      <div className={classes}>
        <p className="team__social-paragraph">
          עקבו אחרינו ברשתות החברתיות וצפו בעבודות שאנחנו עושים
        </p>

        {withSocialLinks ? (
          <div className="team__social-icons">
            {SOCIAL_LINKS.map(({ label, logo: Logo, url }) => (
              <ExternalLink
                key={label}
                className="team__social-icon"
                ariaLabel={LOCALES.GO_TO_X_PAGE.replace('{X}', label)}
                href={url || ''}
              >
                <Logo />
              </ExternalLink>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default Team;
